<template>
    <div>
        <b-button
            @click="
                $router.push({
                    name: 'clientContactsPage',
                    params: { clientId: clientId },
                })
            "
            variant="primary"
            ><i class="fa fa-arrow-left" aria-hidden="true"></i
        ></b-button>
        <app-sub-title :text="`Contacto cliente ${client.name}`" />
        <b-card
            title="Información básica"
            tag="article"
            style="max-width: 100%;"
            class="mb-2"
        >
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="4">
                        <app-form-select-input
                            label="Sede"
                            :required="true"
                            :hasError="$v.theContact.venueId.$error"
                            errorMessage="Debe seleccionar la sede"
                            @input="$v.theContact.venueId.$touch()"
                            v-model="theContact.venueId"
                            :options="venues"
                        />
                    </b-col>

                    <b-col cols="12" md="4">
                        <app-form-text-input
                            label="Nombre"
                            id="name"
                            :required="true"
                            :hasError="$v.theContact.firstName.$error"
                            errorMessage="Debe escribir el nombre"
                            @input="$v.theContact.firstName.$touch()"
                            v-model="theContact.firstName"
                        />
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-form-text-input
                            label="Apellido"
                            id="lastName"
                            :required="true"
                            :hasError="$v.theContact.lastName.$error"
                            errorMessage="Debe escribir el apellido"
                            @input="$v.theContact.lastName.$touch()"
                            v-model="theContact.lastName"
                        />
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-form-text-input
                            label="Documento"
                            id="document"
                            :required="true"
                            :hasError="$v.theContact.document.$error"
                            errorMessage="Debe escribir el documento"
                            @input="$v.theContact.document.$touch()"
                            v-model="theContact.document"
                        />
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="form-group">
                            <label for="">Fecha de nacimiento</label>
                            <b-form-input
                                type="date"
                                v-model="theContact.birthdate"
                            ></b-form-input>
                        </div>
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-form-text-input
                            label="Rol"
                            id="position"
                            v-model="theContact.position"
                        />
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-form-text-input
                            label="Correo"
                            id="email"
                            :required="true"
                            :hasError="$v.theContact.email.$error"
                            errorMessage="Debe escribir un correo valido"
                            @input="$v.theContact.email.$touch()"
                            v-model="theContact.email"
                        />
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-form-text-input
                            label="Dirección"
                            id="address"
                            v-model="theContact.address"
                        />
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-form-text-input
                            label="Teléfono principal"
                            id="phone1"
                            v-model="theContact.phonePrimary"
                        />
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-form-text-input
                            label="Teléfono secundario"
                            id="phone2"
                            v-model="theContact.phoneSecondary"
                        />
                    </b-col>
                    <b-col cols="12" md="4">
                        <br />
                        <b-form-checkbox
                            id="main"
                            v-model="theContact.main"
                            :value="1"
                            :unchecked-value="0"
                        >
                            Contacto principal
                        </b-form-checkbox>
                    </b-col>
                </b-row>
            </div>
        </b-card>

        <b-card
            title="Información detallada"
            tag="article"
            style="max-width: 100%;"
            class="mb-2"
        >
            <div class="card-text">
                <b-row>
                    <b-col
                        cols="12"
                        md="4"
                        v-for="(question, i) in questions"
                        :key="i"
                    >
                        <app-form-text-input
                            :label="question.question"
                            @change="
                                $event =>
                                    setQuestion(
                                        question.id,
                                        $event.target.value
                                    )
                            "
                            :value="getFieldValue(question.id)"
                        />
                    </b-col>
                </b-row>
            </div>
        </b-card>
        <div class="buttons pull-right">
            <b-button v-if="isSave" @click="save" variant="confirm"
                >Guardar</b-button
            >
            <b-button v-if="!isSave" variant="confirm" @click="updateAllInfo"
                >Actualizar</b-button
            >
        </div>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import contactsRepository from '../../../../../repositories/contacts.repository.js'
import clientsRepository from '../../../../../repositories/clients.repository.js'
import DatePicker from '../../../../UI/Controls/DateTimePicker/DateTimePicker.vue'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
export default {
    components: {
        appDatePicker: DatePicker,
        appDatepicker: Datepicker,
    },
    props: {
        contact: {
            type: Object,
        },
        isSave: {
            type: Boolean,
            default: true,
        },
        clientId: {
            required: true,
        },
    },
    data() {
        return {
            theContact: {
                firstName: '',
                lastName: '',
                document: '',
                email: '',
                phonePrimary: '',
                phoneSecondary: '',
                address: '',
                venueId: '',
                birthdate: '',
                position: '',
                main: 0,
            },
            selectedDate: '',
            answers: [],
            questions: [],
            venues: [],
            es: es,
        }
    },

    validations: {
        theContact: {
            firstName: { required },
            lastName: { required },
            venueId: { required },
            email: { email },
            document: { required },
        },
    },

    watch: {
        selectedDate(val) {
            if (!this.theContact.birthdate) return ''
            this.theContact.birthdate = moment(val).format('DD/MM/YYYY')
        },
    },

    methods: {
        customFormatter(date) {
            return moment(date).format('DD/MM/YYYY')
        },
        getFieldValue(questionId) {
            if (this.answers.length) {
                return !!this.answers.find(
                    item => item.questionId === questionId
                )
                    ? this.answers.find(item => item.questionId === questionId)
                          .answer
                    : ''
            }
        },
        loadVenues() {
            const cr = { ...clientsRepository }
            cr.getVenuesByClient(this.clientId)
                .then(data => (this.venues = data))
                .catch(error =>
                    toastr.error('Error al cargar las sedes del cliente')
                )
        },
        save() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const cr = { ...contactsRepository }
            cr.saveContact(this.theContact)
                .then(data => {
                    toastr.success(data.msg)
                    this.theContact = data.contact
                    this.saveAditionalInformation()
                    Object.keys(data.contact).map(
                        key =>
                            (this.theContact[key.toCamel()] = data.contact[key])
                    )
                    this.$router.push({
                        name: 'clientContactsPage',
                        params: { clientId: this.clientId },
                    })
                })
                .catch(error => {
                    toastr.error('Error al guardar contacto')
                })
        },
        saveAditionalInformation() {
            const formData = new FormData()
            this.answers.map(item => {
                formData.append('answers[answers][]', item.answer)
                formData.append('answers[questionsId][]', item.questionId)
            })
            formData.append('contactId', this.theContact.id)

            const cr = { ...contactsRepository }
            return cr.saveInfoData(formData)
        },
        update() {
            const cr = { ...contactsRepository }
            return cr.updateContact(
                this.theContact,
                !!this.contact ? this.contact.id : this.theContact.id
            )
        },
        updateAllInfo() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            Promise.all([this.update(), this.saveAditionalInformation()])
                .then(results => {
                    toastr.success('Información guardada satisfactoriamente')
                    this.$router.push({
                        name: 'clientContactsPage',
                        params: { clientId: this.clientId },
                    })
                })
                .catch(error => {
                    toastr.error('Ocurrio un error al guardar la información')
                })
        },
        fillForm() {
            this.selectedDate = this.contact.birthdate
            Object.keys(this.contact).map(
                key => (this.theContact[key.toCamel()] = this.contact[key])
            )
            this.contact.contact_info_data.map(item => {
                let answ = {
                    answer: item.value,
                    questionId: item.contact_info_conf_id,
                }
                this.answers.push(answ)
            })
        },
        loadContactInfoConf() {
            const cr = { ...contactsRepository }
            cr.getContactInfoConf()
                .then(data => (this.questions = data))
                .catch(error =>
                    toastr.error('Error al cargar las preguntas detalladas')
                )
        },
        setQuestion(questionId, answer) {
            let current = this.answers.findIndex(
                item => item.questionId === questionId
            )
            if (current !== -1) {
                this.answers[current].answer = answer.trim()
            } else {
                let answ = {
                    questionId,
                    answer: answer.trim(),
                }
                this.answers.push(answ)
            }
        },
    },
    created() {
        this.loadVenues()
        this.loadContactInfoConf()
        if (!this.isSave) {
            this.fillForm()
        }
    },
}
</script>
<style>
#birthdate {
    width: 100%;
    border-color: transparent transparent;
}
</style>
